import { render, staticRenderFns } from "./SchoolInfo.vue?vue&type=template&id=959eab34&scoped=true&"
import script from "./SchoolInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInfo.vue?vue&type=style&index=0&id=959eab34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959eab34",
  null
  
)

export default component.exports